import { render, staticRenderFns } from "./coderProList.vue?vue&type=template&id=cdffdac2&scoped=true&"
import script from "./coderProList.vue?vue&type=script&lang=js&"
export * from "./coderProList.vue?vue&type=script&lang=js&"
import style0 from "./coderProList.vue?vue&type=style&index=0&id=cdffdac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdffdac2",
  null
  
)

export default component.exports